import React from "react";
import { Tooltip, IconButton } from "@mui/material";

const RestrictedIconButton = ({
    title,
    onClick,
    disabled = false,
    icon: Icon,
    iconColor = "#6ebe44",
    fontSize = "20px"
}) => {
    return (
        <Tooltip title={title}>
            <span style={{ cursor: disabled ? "not-allowed" : "pointer" }}>
                <IconButton
                    disabled={disabled}
                    sx={{ cursor: disabled ? "not-allowed" : "pointer" }}
                >
                    <Icon
                        style={{
                            color: disabled ? "#aaa" : iconColor,
                            fontSize,
                        }}
                        onClick={() => {
                            if (!disabled && typeof onClick === "function") {
                                onClick();
                            }
                        }}
                    />
                </IconButton>
            </span>
        </Tooltip>
    );
};

export default RestrictedIconButton;
